import styled from "@emotion/styled";

import { Menu } from "metabase/ui";

export const AdminEmbedMenuContainer = styled(Menu.Dropdown)`
  overflow: auto;
`;
